export default __webpack_public_path__ + "static/media/shopping-cart.96c73cb4.png";